import {React} from "react";
import { useNavigate } from "react-router-dom";
import "./aboutsection.css";
import "./app-wide.css";


const AboutSection = () =>
{
    const navigate = useNavigate();

    const navigateToSignUp = () =>{
        navigate("/login?fromSignup=true")
    }

   return(
     
    <div>
        <div className="grid-container">
            <div class="grid-item">
               <h1 className="grid-container-item-h1">Easy Holistic Stock Data</h1>
                <p className="grid-container-item-p">Stock Archives offers a complete historical stock data solution for small, mid, and large-cap companies—available via API, interactive dashboard, and Excel export. Ideal for analysts, quants, individual investors, and financial professionals seeking fast, flexible access to market data for deeper insights and smarter decision-making.</p>
            </div>
            <div class="grid-item">
                <div className="grid-container-2">
                    <div className="grid-item">
                        
                    </div>
                    <div className="grid-item grid-container-2-top-right drop-shadow">
                        
                    </div>
                    <div className="grid-item grid-container-2-bottom-left drop-shadow">
                        
                    </div>
                    <div className="grid-item">
                        
                    </div>
                </div>
            </div>
        </div>
        <div className="signup-button-container">
            <button onClick={navigateToSignUp} type="button" className="signup-button drop-shadow">Sign up</button>
        </div>

         
    </div>
    );
}

export default AboutSection;